<!-- Step: SUPPORT REQUEST FORM -->
<div
  id="step-request-form"
  class="flex min-h-0 flex-1 flex-col"
>
  <form
    id="request-form"
    class="flex flex-1 flex-col pt-6"
    *ngIf="!submitSuccess; else requestSuccess"
    (ngSubmit)="submitForm()"
    #supportRequestForm="ngForm"
  >
    <div class="space-y-6">
      <div id="request-form-header" class="space-y-2">
        <h2 class="fdk-type-heading-2 text-fdk-primary">Report an issue</h2>
        <p class="fdk-type-paragraph text-fdk-secondary">
          Sharing your email address helps us follow up with you directly.
        </p>
      </div>

      <!-- Warning block shown when error inputs are provided (from prior sign-in/connect flow) -->
      <fdk-alert
        *ngIf="error || error_description"
        title="We detected an issue during sign-in. These details will be included with your support request."
        [description]="signInWarningDescription"
        variant="warning"
      />

      <div class="space-y-4">
        <fdk-input
          [(ngModel)]="formSupportRequest.email"
          name="email"
          label="Your email address"
          type="email"
          autocomplete="email"
          placeholder="you@example.com"
          required
        />

        <fdk-input
          [(ngModel)]="formSupportRequest.healthsystem_name"
          name="healthsystem_name"
          label="Health system name"
          type="text"
          placeholder="Mayo Clinic, Cleveland Clinic, Kaiser Permanente"
          required
        />

        <fdk-textarea
          [(ngModel)]="formSupportRequest.request_content"
          name="request_content"
          label="Describe your technical issue"
          placeholder="Please provide as much detail as possible about the error. It helps us prioritize your issue."
          required
        />
      </div>
    </div>

    <!-- Submission error block -->
    <div class="mt-fdk-s">
      <fdk-alert
        *ngIf="errorMsg"
        title="We couldn't submit your request."
        [description]="errorMsg"
        variant="error"
      />
    </div>

    <div class="support-request-actions mt-auto pt-6">
      <fdk-button
        id="support-request-submit"
        type="submit"
        variant="primary"
        width="full"
        [disabled]="!supportRequestForm.form.valid || loading"
      >
        <span class="flex items-center justify-center gap-2"
          ><fdk-spinner *ngIf="loading" /> Submit</span
        >
      </fdk-button>
    </div>
  </form>
</div>
<!-- End Step: REQUEST FORM -->

<ng-template #requestSuccess>
  <!-- Success animation container -->
  <div
    id="request-success-animation"
    class="flex flex-1 flex-col pt-16 text-center"
  >
    <div>
      <fdk-illustration name="success" />
      <h2 class="fdk-type-heading-2 text-fdk-primary">Issue received</h2>
      <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
        Thanks for letting us know. We'll be in touch once we have an update.
      </p>
    </div>

    <div class="support-request-success-actions mt-auto pt-6">
      <fdk-button
        id="support-request-done"
        type="button"
        variant="secondary"
        width="full"
        (click)="dismiss()"
      >
        Done
      </fdk-button>
    </div>
  </div>
</ng-template>
